// extracted by mini-css-extract-plugin
export default {"wrapper":"EBFVBy","active":"xehaOA"};